<template>
  <router-link
    class="flex items-center px-2 py-2 text-sm font-medium leading-6 text-teal-100 rounded-md group hover:text-white hover:bg-teal-600"
    active-class="flex items-center px-2 py-2 text-sm font-medium leading-6 text-white bg-teal-800 rounded-md group"
    :to="to"
    @click.stop
  >
    <ld-icon
      class="w-6 h-6 text-teal-200"
      :icon="icon"
    />
    <span
      v-if="!hideLabel"
      class="ml-4"
    >{{ label }}</span>
  </router-link>
</template>

<script setup lang="ts">
  const props = withDefaults(
    defineProps<{ icon: string; label: string; to: any; hideLabel: boolean }>(),
    {},
  )
</script>
